export const STATUS_SYNC = 'status_sync';

export const STATUS_PUSH = 'status_push';

export const APPOINTMENT_SYNC = 'appointment_sync';

export const APPOINTMENT_PUSH = 'appointment_push';

export const USER_MAP = 'user_map';

export const DVI_PUSH = 'dvi_push';

export const DVI_SHEET_MAP = 'dvi_sheet_map';

export const DVI_PACKAGE_MAP = 'dvi_package_map';

export const RO_PULL = 'ro_pull';

export const RO_RECALCULATE = 'ro_recalculate';

export const WO_SYNC = 'wo_sync';

export const WO_PULL = 'wo_pull';

export const WO_PUSH = 'wo_push';

export const HISTORY_PULL = 'history_pull';

export const FORCE_HISTORY_COLLECT = 'force_history_collect';

export const DEFERRED_SERVICES = 'deferred_services';

export const SUBHEADER_THEME = 'subheader_theme';

export const INTEGRATED_SCHEDULER = 'integrated_scheduler';

export const REVERSE_STATUS_SYNC = 'reverse_status_sync';

export const SHOP_MANAGEMENT_SYSTEM_API_CREDS = 'shop_management_system_api_creds';

export const WO_REGENERATE = 'wo_regenerate';

export const DVI_RECOMMENDATION_SMS_CODES = 'dvi_recommendation_sms_codes';
